export default {
  path: '/withDrawTran',
  meta: {
    title: '转换购物券',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/withDrawTran`),
}



// WEBPACK FOOTER //
// ./src/views/WithDrawTran/router.js